module.exports = __webpack_public_path__ + "static/media/evi-view.b804a09c.png";